import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "../../shared/header/header";
import { AppProgressComponent } from "../../shared/progress/progress";
import { filter, map, Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { FooterComponent } from "../../shared/footer/footer";

@Component({
    selector: 'mi-request',
    standalone: true,
    imports: [RouterOutlet,
        HeaderComponent,
        CommonModule,
        AppProgressComponent,
        FooterComponent
    ],
    templateUrl: './request.html',
    styleUrl: './request.scss',
    encapsulation: ViewEncapsulation.None
})
export class RequestComponent implements OnInit {

    isNeedProgress: boolean = false;
    isNeedMainHeader: boolean = false;
    requestText: any;
    subscriptions: Subscription = new Subscription();

    constructor(
        private router: Router,
        private translateService: TranslateService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.subscribeRoute();
        this.initText();
    }

    initText() {
        this.subscriptions.add(this.translateService.stream('request').subscribe(translation => {
            this.requestText = translation;
        }));
    }

    subscribeRoute() {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            map((route) => route.snapshot.data)
        ).subscribe((data) => {
            this.isNeedProgress = data['stepCondition'];
            this.isNeedMainHeader = data['isVisibleMainHeader'];
        });
    }

    isHomePage(): boolean {
        return this.router.url === '/';
    }
}